import { Perimeter } from "@nova/protobuf"
import { ProjectWithMetadata } from "@nova/constants"
import { createPolygonKML } from "@nova/data-create-polygon-kml"
import { coordToArr, coordToArrStrict } from "@nova/calculate-geospatial"
import { decodeNumberToColor } from "@nova/serializer/src/client/util"
import { generateBufferLinesAsync } from "@nova/calculate-buffers"
import { entityIsVisible } from "@nova/util-side-panel"
import { convertColourToKMLColour } from "@nova/util-strings"
import { perimeterFeatures } from "./caltopo"

export const getPerimeterKMLForProject = (project: ProjectWithMetadata) => {
    const perimeterPolygons = project.perimeters
        .filter((e) => e.visible && !e.archivedTimestamp)
        .flatMap((e) => e.polygons)
    if (perimeterPolygons.length > 0) {
        return createPolygonKML(
            "perimeter.kml",
            perimeterPolygons.map((e) => ({
                coords: e.coordinates.map((e) => coordToArr(e) as [number, number]),
                color: "FF1A1AE5",
            }))
        )
    } else return undefined
}

export const getPerimeterOutlinesKMLForProject = (project: ProjectWithMetadata) =>
    createPolygonKML(
        "",
        project.perimeters.filter(entityIsVisible(project)).flatMap((e) =>
            e.polygons.map((polygon) => ({
                coords: polygon.coordinates.map(coordToArrStrict),
                width: e.width,
                color: e.outline
                    ? convertColourToKMLColour(decodeNumberToColor(e.outline))
                    : "FF1A1AE5",
            }))
        )
    )

export const perimeterTransformer = (perimeter: Perimeter, project: ProjectWithMetadata) => {
    return {
        perimeterKML: async () => {
            const bufferPolygons = perimeter.buffers
                ? (await generateBufferLinesAsync(perimeter.polygons, perimeter.buffers))
                      .flat()
                      .map((bufferPolygon) => ({
                          coords: bufferPolygon.coordinates.map(
                              (e) => coordToArr(e) as [number, number]
                          ),
                          color: bufferPolygon.color
                              ? decodeNumberToColor(bufferPolygon.color, { isKml: true })
                              : "FF1A1AE5",
                          width: bufferPolygon.width,
                      }))
                : []

            return createPolygonKML(perimeter.name, [
                ...perimeter.polygons.map((e) => ({
                    coords: e.coordinates.map((e) => coordToArr(e) as [number, number]),
                    color: perimeter.outline
                        ? decodeNumberToColor(perimeter.outline, { isKml: true })
                        : "FF1A1AE5",
                    width: perimeter.width,
                })),
                ...bufferPolygons,
            ])
        },
        perimeterToCalTopo: () => perimeterFeatures(perimeter),
        entity: perimeter,
        project,
    }
}
